import React, { useEffect, useState } from "react";
import "./OnlineSubmission.css";
import { generateCaptchaCode, validateCaptcha } from "../../../utiles/generateCaptcha";
import { FaSync } from "react-icons/fa";


export default function OnlineSubmission() {
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [formData, setFormData] = useState({
    paperTitle: "",
    authorName: "",
    authorEmail: "",
    authorInfo: "",
    address: "",
    country: "",
    paperType: "",
    reviewer: "",
    copyrightFile: null,
    paperFile: null,
    abstract: "",
    keywords: "",
    captcha: "",
  });

  // 🟢 Initially no authors (empty array)
  const [authors, setAuthors] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
      setCaptcha(generateCaptchaCode());
    }, []);

    const refreshCaptcha = () => {
      setLoading(true);

      // simulate loading delay
      setTimeout(() => {
        setCaptcha(generateCaptchaCode());
        setLoading(false);
      }, 500);
    };


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  // Handle author input change
  const handleAuthorChange = (index, field, value) => {
    const updatedAuthors = [...authors];
    updatedAuthors[index][field] = value;
    setAuthors(updatedAuthors);
  };

  // Add new author
  const addAuthor = () => {
    setAuthors([...authors, { name: "", email: "" }]);
  };

  // Remove author
  const removeAuthor = (index) => {
    const updatedAuthors = authors.filter((_, i) => i !== index);
    setAuthors(updatedAuthors);
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.paperTitle) newErrors.paperTitle = "Paper title is required";
    if (!formData.authorName) newErrors.authorName = "Author name is required";
    if (!formData.authorEmail) {
      newErrors.authorEmail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.authorEmail)) {
      newErrors.authorEmail = "Enter a valid email address";
    }
    if (!formData.paperType) newErrors.paperType = "Paper type is required";
    if (!formData.reviewer) newErrors.reviewer = "Reviewer info is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.copyrightFile)
      newErrors.copyrightFile = "Copyright file required";
    if (!formData.paperFile) newErrors.paperFile = "Paper file required";

    const errorMsg = validateCaptcha(captchaInput, captcha);
    if (errorMsg) {
      setErrors({ captcha: errorMsg });
      return;
    }

    authors.forEach((author, i) => {
      if (!author.name)
        newErrors[`authorName${i}`] = `Author ${i + 1} name is required`;
      if (!author.email)
        newErrors[`authorEmail${i}`] = `Author ${i + 1} email is required`;
      else if (!/\S+@\S+\.\S+/.test(author.email))
        newErrors[`authorEmail${i}`] = `Enter a valid email for Author ${
          i + 1
        }`;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      console.log("✅ Form submitted successfully:", formData, authors);
      alert("Form submitted successfully!");
    } else {
      console.log("❌ Validation errors:", errors);
    }
  };

  return (
    <div className="ijacna-os-form-container">
      <h2 className="ijacna-os-form-title">Online Paper Submission</h2>

      <form className="ijacna-os-form-wrapper" onSubmit={handleSubmit}>
        <div className="ijacna-os-grid">
          {/* Left Column */}
          <div className="ijacna-os-column">
            <div className="ijacna-os-form-group">
              <label>
                Paper Title <span>*</span>
              </label>
              <input
                type="text"
                name="paperTitle"
                className={`ijacna-os-input ${
                  errors.paperTitle ? "error" : ""
                }`}
                placeholder="Enter your paper title"
                onChange={handleChange}
              />
              {errors.paperTitle && (
                <p className="ijacna-os-error">{errors.paperTitle}</p>
              )}
            </div>

            <div className="ijacna-os-form-group">
              <label>
                Name of Corresponding Author <span>*</span>
              </label>
              <input
                type="text"
                name="authorName"
                className={`ijacna-os-input ${
                  errors.authorName ? "error" : ""
                }`}
                placeholder="Author full name"
                onChange={handleChange}
              />
              {errors.authorName && (
                <p className="ijacna-os-error">{errors.authorName}</p>
              )}
            </div>

            <div className="ijacna-os-form-group">
              <label>
                Email of Corresponding Author <span>*</span>
              </label>
              <input
                type="email"
                name="authorEmail"
                className={`ijacna-os-input ${
                  errors.authorEmail ? "error" : ""
                }`}
                placeholder="example@email.com"
                onChange={handleChange}
              />
              {errors.authorEmail && (
                <p className="ijacna-os-error">{errors.authorEmail}</p>
              )}
            </div>

            <div className="ijacna-os-form-group">
              <label>Corresponding Author Secondary Information</label>
              <input
                type="text"
                name="authorInfo"
                placeholder="Phone, designation, etc."
                onChange={handleChange}
              />
            </div>

            {/* Authors Section */}
            {authors.length > 0 && (
              <div className="ijacna-os-authors-list">
                {authors.map((author, index) => (
                  <div key={index} className="ijacna-os-author-block">
                    <h4 className="ijacna-os-author-title">
                      Author {index + 1} :
                    </h4>

                    <div className="ijacna-os-form-group">
                      <label>Name of Author</label>
                      <input
                        type="text"
                        placeholder="Author name"
                        className={`ijacna-os-input ${
                          errors[`authorName${index}`] ? "error" : ""
                        }`}
                        value={author.name}
                        onChange={(e) =>
                          handleAuthorChange(index, "name", e.target.value)
                        }
                      />
                      {errors[`authorName${index}`] && (
                        <p className="ijacna-os-error">{errors[`authorName${index}`]}</p>
                      )}
                    </div>

                    <div className="ijacna-os-form-group author-email-group">
                      <label>Email of Author</label>
                      <div className="ijacna-os-email-field">
                        <input
                          type="email"
                          placeholder="Author email"
                          className={`ijacna-os-input ${
                            errors[`authorEmail${index}`] ? "error" : ""
                          }`}
                          value={author.email}
                          onChange={(e) =>
                            handleAuthorChange(index, "email", e.target.value)
                          }
                        />
                        <button
                          type="button"
                          className="ijacna-os-remove-btn"
                          onClick={() => removeAuthor(index)}
                        >
                          ❌
                        </button>
                      </div>
                      {errors[`authorEmail${index}`] && (
                        <p className="ijacna-os-error">{errors[`authorEmail${index}`]}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Add author button */}
            <button
              type="button"
              className="ijacna-os-form-add-btn"
              onClick={addAuthor}
            >
              + Add New Author
            </button>

            <div className="ijacna-os-form-group">
              <label>
                Address with Pin/Zip Code <span>*</span>
              </label>
              <textarea
                name="address"
                className={`ijacna-os-input ${errors.address ? "error" : ""}`}
                placeholder="Enter complete address"
                onChange={handleChange}
              ></textarea>
              {errors.address && <p className="ijacna-os-error">{errors.address}</p>}
            </div>

            <div className="ijacna-os-form-group">
              <label>Country</label>
              <select name="country" onChange={handleChange}>
                <option value="">Select Country</option>
                <option>India</option>
                <option>USA</option>
                <option>UK</option>
                <option>Australia</option>
                <option>Canada</option>
              </select>
            </div>
          </div>

          {/* Right Column */}
          <div className="ijacna-os-column">
            <div className="ijacna-os-form-group">
              <label>
                Paper Type <span>*</span>
              </label>
              <input
                type="text"
                name="paperType"
                className={`ijacna-os-input ${errors.paperType ? "error" : ""}`}
                placeholder="Research / Review / Case Study"
                onChange={handleChange}
              />
              {errors.paperType && <p className="ijacna-os-error">{errors.paperType}</p>}
            </div>

            <div className="ijacna-os-form-group">
              <label>
                Suggested Reviewer <span>*</span>
              </label>
              <input
                type="text"
                name="reviewer"
                className={`ijacna-os-input ${errors.reviewer ? "error" : ""}`}
                placeholder="Reviewer names and emails"
                onChange={handleChange}
              />
              {errors.reviewer && <p className="ijacna-os-error">{errors.reviewer}</p>}
            </div>

            <div className="ijacna-os-form-group">
              <label>
                Upload Scanned Copy of Copyright Form <span>*</span>
              </label>
              <div className={`ijacna-os-custom-file-upload ${errors.copyrightFile ? "error" : ""}`}>
                <label htmlFor="copyrightFile" className="ijacna-os-upload-btn">
                  Choose File
                </label>
                <span className="ijacna-os-file-name">
                  {formData.copyrightFile?.name || "No file chosen"}
                </span>
                <input
                  id="copyrightFile"
                  type="file"
                  name="copyrightFile"
                  accept=".pdf,.jpg,.png"
                  onChange={handleChange}
                />
              </div>
              {errors.copyrightFile && (
                <p className="ijacna-os-error">{errors.copyrightFile}</p>
              )}
            </div>

            <div className="ijacna-os-form-group">
              <label>
                Upload Paper in MS Word (.doc or .docx) <span>*</span>
              </label>
              <div className={`ijacna-os-custom-file-upload ${errors.paperFile ? "error" : ""}`}>
                <label htmlFor="paperFile" className="ijacna-os-upload-btn">
                  Choose File
                </label>
                <span className="ijacna-os-file-name">
                  {formData.paperFile?.name || "No file chosen"}
                </span>
                <input
                  id="paperFile"
                  type="file"
                  name="paperFile"
                  accept=".doc,.docx"
                  onChange={handleChange}
                />
              </div>
              {errors.paperFile && <p className="ijacna-os-error">{errors.paperFile}</p>}
            </div>

            <div className="ijacna-os-form-group">
              <label>Abstract</label>
              <textarea
                name="abstract"
                placeholder="Brief abstract of your paper"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="ijacna-os-form-group">
              <label>Keywords</label>
              <textarea
                name="keywords"
                placeholder="Enter keywords separated by commas"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="ijacna-os-form-captcha">
              <div className="ijacna-os-captcha-box">{captcha}</div>
               <button type="button" className="captcha-refresh-btn" onClick={refreshCaptcha}>
              {loading ? (
                <span className="captcha-spinner"></span>
              ) : (
                <FaSync className="captcha-refresh-icon" />
              )}
            </button>
              <input
                type="text"
                name="captcha"
                className={`ijacna-os-input ${errors.captcha ? "error" : ""}`}
                placeholder="Enter the code"
                onChange={(e) => setCaptchaInput(e.target.value)}
              />
            </div>
            {errors.captcha && <p className="ijacna-os-error">{errors.captcha}</p>}
            <button type="submit" className="ijacna-os-form-submit-btn">
              Submit Paper
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
